var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGavel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8075 21.0868H12.8075C13.3575 21.0868 13.8075 21.5368 13.8075 22.0868C13.8075 22.6368 13.3575 23.0868 12.8075 23.0868H2.8075C2.2575 23.0868 1.8075 22.6368 1.8075 22.0868C1.8075 21.5368 2.2575 21.0868 2.8075 21.0868ZM6.04749 8.15684L8.87749 5.32684L21.6075 18.0568C22.3875 18.8368 22.3875 20.1068 21.6075 20.8868C20.8275 21.6668 19.5575 21.6668 18.7775 20.8868L6.04749 8.15684ZM14.5375 2.49684L17.3675 5.32684C18.1475 6.10684 18.1475 7.37684 17.3675 8.15684L15.9475 9.57684L10.2975 3.91684L11.7075 2.50684C12.4875 1.71684 13.7575 1.71684 14.5375 2.49684ZM4.6375 9.56684L10.2975 15.2268L8.8875 16.6368C8.1075 17.4168 6.83749 17.4168 6.0575 16.6368L3.2275 13.8068C2.4475 13.0268 2.4475 11.7568 3.2275 10.9768L4.6375 9.56684Z",
    fill: "#8B8D9E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGavel);
export default __webpack_public_path__ + "static/media/gavel.075b96f615c4ad87aeb51a85d0eeeaff.svg";
export { ForwardRef as ReactComponent };